import React from "react";
import { Controller, useFormState } from "react-hook-form";

const CampoFormulario = React.forwardRef(
    (
        {
            name,
            label,
            Component,
            rules,
            variant = "outlined",
            size = "small",
            control, formularioControlador,
            ...restProps
        },
        ref
    ) => {
        const formState = useFormState();
        return (
            <Controller
                name={name}
                ref={ref}
                control={control}
                render={({ field: { onChange, onBlur, value, ref } }) => (
                    <Component
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        ref={ref}
                        error={Boolean(
                            formState.errors && formState.errors[name]
                        )}
                        helperText={
                            formState.errors && formState.errors[name]?.message
                        }
                        label={label}
                        variant={variant}
                        size={size}
                        name={name}
                        control={control}
                        formularioControlador={formularioControlador}
                        {...restProps}
                        fullWidth
                    />
                )}
                rules={rules}
            />
        );
    }
);

export default CampoFormulario;
